import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The default behaviour is to keep the same scroll position when you change Routes. this sends the scroll to the top
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
